/**
 * /tenants/{slug}/automation-accounts/$id — tenant-scoped detail.
 */

import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import {
  fetchAutomationAccount,
  scopeKey,
} from "@/features/automation-accounts/queries";
import { queryKeys } from "@/lib/query-keys";
import { AutomationAccountDetailPage } from "@/features/automation-accounts/pages/automation-account-detail-page";

function TenantAutomationAccountDetailPage() {
  const { tenant } = Route.useRouteContext();
  const { slug, id } = Route.useParams();
  const navigate = useNavigate();
  const backTo = `/tenants/${slug}/automation-accounts`;
  return (
    <AutomationAccountDetailPage
      tenantID={tenant.id}
      id={id}
      scope="tenant"
      basePath={backTo}
      onBackToList={() =>
        void navigate({
          to: "/tenants/$slug/automation-accounts",
          params: { slug },
        })
      }
      renderBackLink={({ children, className }) => (
        <Link
          to="/tenants/$slug/automation-accounts"
          params={{ slug }}
          className={className}
        >
          {children}
        </Link>
      )}
      // Deep-link into the tenant audit page pre-filtered on the
      // account's admin_users UUID as the TARGET (resource_id). See
      // the platform shim comment for the actor-vs-target split.
      renderAuditLink={({ children }) => (
        <Link
          to="/tenants/$slug/audit"
          params={{ slug }}
          search={{ resource_id: id }}
        >
          {children}
        </Link>
      )}
    />
  );
}

export const Route = createFileRoute(
  "/_authed/tenants/$slug/automation-accounts/$id",
)({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData({
      queryKey: queryKeys.automationAccounts.detail(
        scopeKey(context.tenant.id),
        params.id,
      ),
      queryFn: () => fetchAutomationAccount(context.tenant.id, params.id),
    }),
  component: TenantAutomationAccountDetailPage,
});
